import React from 'react'
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  RadioGroupProps as MuiRadioGroupProps,
  Stack,
  Typography,
} from '@mui/material'

export interface RadioGroupProps {
  label?: string
  value?: string
  row?: MuiRadioGroupProps['row']
  items: Array<{ title: string; value: any }>
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void
  onLoad?: (choose: string) => void
}

export const RadioGroup = ({
  row = false,
  items,
  label,
  onChange,
  value,
  onLoad,
}: RadioGroupProps): React.ReactElement => {
  return (
    <FormControl fullWidth>
      <Stack direction={row ? 'row' : 'column'} gap={3} alignItems="center">
        {label && (
          <Typography
            variant="body1"
            color="text.secondary"
            onClick={() => value && onLoad?.(value)}
            sx={
              onLoad
                ? {
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    '&:hover': {
                      color: 'primary.main',
                    },
                  }
                : {}
            }
          >
            {label}
          </Typography>
        )}
        <MuiRadioGroup row={row} onChange={onChange} value={value}>
          {items.map((radioItem) => (
            <FormControlLabel
              control={<Radio />}
              label={radioItem.title}
              key={radioItem.value}
              value={radioItem.value}
            />
          ))}
        </MuiRadioGroup>
      </Stack>
    </FormControl>
  )
}
